import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: "", //用户登录token
        currentRole: 0, //当前用户身份 默认为游客  游客=0  教师=1  学生=2
        user: {},
        // 登陆弹窗
        loginModal: false,

    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_USER(state, user) {
            state.user = {...state.user, ...user };
            let userInfo = JSON.parse(localStorage.getItem('USER'));
            let kongArr = {...userInfo };
            for (const key in user) {
                if (!kongArr[key] || kongArr[key] == null) {
                    kongArr[key] = user[key];
                }
            }
            // userInfo = {...user, ...userInfo }
            localStorage.setItem("USER", JSON.stringify(kongArr));
        },
        SET_LOGOUT(state) {
            state.token = "";
            state.user = {};
            localStorage.removeItem('USER');
            localStorage.removeItem("type");
        },
        //判断是否登录
        iS_LOGIN(state, obj) {
            obj(localStorage.getItem('USER') ? true : false)
        },
        SET_LOGIN_MODAL(state, login) {
            state.loginModal = login;
        },
    },
    actions: {
        async getUserInfo({ commit, state }, res) {
            commit("SET_USER", JSON.parse(res));
            // 写入storage
            localStorage.setItem("USER", JSON.stringify(state.user));
        },
    },
    modules: {}
})